import { lerp } from "../../../core/util/MathUtil";
import { BaseVectorFilter } from "../BaseVectorFilter";
import { SegmentFilterContext, VectorSegment } from "../VectorSprite";

/**
 * Flicker filter that modulates segment alpha based on time and intensity
 */
export class FlickerFilter extends BaseVectorFilter {
  public intensity: number = 0; // 0 = no flicker, 1 = maximum flicker

  constructor(
    private frequency: number = 8, // flickers per second
    private minAlpha: number = 0.3, // minimum alpha when flickering
  ) {
    super();
  }

  apply(
    segments: VectorSegment[],
    context: SegmentFilterContext,
  ): VectorSegment[] {
    if (this.intensity <= 0) {
      return segments; // No flicker effect
    }

    // Calculate flicker phase using sine wave
    const flickerPhase = Math.sin(
      context.totalTime * this.frequency * 2 * Math.PI,
    );

    // When flickerPhase > 0, use full alpha. When < 0, use dimmed alpha
    // Intensity controls how much the effect is applied
    const alphaMultiplier =
      flickerPhase > 0 ? 1.0 : lerp(1.0, 0, this.intensity);

    // Apply alpha modulation to all segments
    return segments.map((segment) => ({
      ...segment,
      alpha: (segment.alpha ?? 1.0) * alphaMultiplier,
    }));
  }
}
